import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      $_tendersSettings: 'getTendersSettings',
    }),
  },
  methods: {
    /**
      * Получить новую цену
      * @param {Number} start_price - начальная цена
      * @param {Number} new_price - новая цена (приходит при ручном указании цены или процента)
      * @param {String|Number} type - тип изменения ('PRICE' или 'PERSENT' или число для расчета процента)
    */
    getNewPrice(start_price, new_price, type) {
      switch (type) {
      case 'PRICE':
        return new_price
      case 'PERSENT':
        return this.roundPrice(
          this.isSale
            ? start_price + (start_price * new_price / 100)
            : start_price - (start_price * new_price / 100)
        )
      default:
        return this.roundPrice(
          this.isSale
            ? start_price + (start_price * type / 100)
            : start_price - (start_price * type / 100)
        )
      }
    },
    roundPrice(value) {
      const digits = this.$_tendersSettings?.priceRoundingDigit ?? 2
      const factor = Math.pow(10, digits)
      return Math.round(value * factor) / factor
    },
    getTextValidateMinPrice(value, lotId) {
      const lot = this.tender?.lots?.find(l => l.lotId === lotId)

      let errorText = null
      if (lot && lot?.bidPriceLimit) {
        if (this.isSale) {
          errorText = value > lot.bidPriceLimit ? `${this.$t('Tenders.MAX')}: ${lot.bidPriceLimit}` : null
        } else {
          errorText = value < lot.bidPriceLimit ? `${this.$t('Tenders.MIN')}: ${lot.bidPriceLimit}` : null
        }
      }
      return errorText
    },
    validateInput(rule, value, callback, type, required = true, lotId = null) {
      if (!type) {
        return callback()
      }
      const hasLimitBidPrice = this.tender.biddingType?.hasLimitBidPrice || false
      if (hasLimitBidPrice) {
        if (value?.price === null) { // Исключительная ситуация. Быть не должно
          return callback(new Error('Не знайдено нове значеня ціни'))
        }
        const textValidateMinPrice = this.getTextValidateMinPrice(value?.price, lotId)
        if (textValidateMinPrice) {
          return callback(new Error(textValidateMinPrice))
        }
      }

      let error_text = type == 'PRICE'
        ? this.$t('Validate.Required')
        : `${this.$t('Tenders.EnterValue')}  ${this.$t('Purchasing.From') } 0.01%`
      let till = !this.isSale ? ` ${this.$t('Common.till')}  100%` : ''
      if ( type == 'PERSENT' && ((required && value.percent < 0.01) || ( !this.isSale && value.percent > 99.9)) ) {
        return callback(new Error( error_text + till ) )
      }
      if ( type == 'PRICE' && required && value.price < 0.01 ) {
        return callback(new Error( error_text ) )
      }
      return callback()
    },
  },
}
